import { api_base } from "Utils/requests";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";

export const httpLink = createUploadLink({
    uri: `${api_base}/graphql/`,
    credentials: "include",
    headers: {
        "Content-Type": "application/json",
    },
});
